import React from "react";
import { Link } from "react-router-dom";
import "./visa.css";

export const Awards = () => {
  return (
    <>
      <div className="visa-big-box container">
        <h5>
          The organizing committee of the Intelligent Human-Computer Interaction
          (IHCI) Society is pleased to announce the call for submissions for the
          Best Paper Awards. These awards aim to recognize and honor outstanding
          contributions in the field of Human-Computer Interaction (HCI). We
          invite researchers and practitioners to submit their original and
          innovative papers to be considered for this prestigious recognition.
        </h5>

        <h4>1. Eligibility</h4>
        <ul>
          <li>
            The paper must be original and not previously published or currently
            under review for any other conference or journal.
          </li>
          <li>
            The content of the paper should align with the themes and scope of
            the IHCI Conference.
          </li>
          <li>Papers from both academia and industry are welcome.</li>
          <li>
            At least one of the authors must register and present the paper at
            the conference.
          </li>
        </ul>

        <h4>2. Submission Guidelines</h4>
        <ul>
          <li>
            Prepare your paper according to the IHCI Conference paper template
            and formatting guidelines.
          </li>
          <li>
            The paper should be written in English and submitted in PDF format.
          </li>
          <li>
            The length of the paper should not exceed the specified page limit
            (typically between 10-12 pages, including references).
          </li>
          <li>
            Include a clear title, abstract, keywords, and author information
            (names, affiliations, and contact details) in the paper.
          </li>
          <li>
            Submit your paper electronically through the online submission
            system before the submission deadline.
          </li>
        </ul>

        <h4>3. Evaluation Process</h4>
        <ul>
          <li>
            All submitted papers will undergo a rigorous review process by a
            panel of experts in the field of HCI.
          </li>
          <li>
            The evaluation criteria will include originality, significance of
            the research, technical quality, clarity of presentation, and
            relevance to the HCI community.
          </li>
          <li>
            The review process will be conducted in a double-blind manner,
            ensuring the anonymity of both the authors and reviewers.
          </li>
          <li>
            Based on the reviewers' feedback and recommendations, a shortlist of
            papers will be selected for final consideration.
          </li>
          <li>
            The final decision for the Best Paper Awards will be made by the
            award committee, taking into account the overall quality and impact
            of the papers.
          </li>
        </ul>

        <h4>4. Best Paper Awards</h4>
        <ul>
          <li>
            The IHCI Conference will present several Best Paper Awards to
            recognize exceptional contributions in different categories, such as
            technical research, user experience design, theoretical foundations,
            and application-oriented papers.
          </li>
          <li>
            Winners will receive a certificate of recognition, an award plaque,
            and the opportunity to present their work in a dedicated session
            during the conference.
          </li>
          <li>
            The Best Paper Awards will be announced and presented during the
            conference closing ceremony.
          </li>
        </ul>

        <h5>
          <b>Note: </b>The IHCI Conference reserves the right to modify any
          information provided in this call for Best Paper Awards. Applicants
          are advised to refer to the official IHCI Conference website for the
          most up-to-date information and submission guidelines.
        </h5>
        <h5>
          For further inquiries or clarifications regarding the Best Paper
          Awards, please contact: <Link to="mailto:ihcisociety@gmail.com">ihcisociety@gmail.com</Link>
        </h5>
      </div>
      <hr className="hr-style" />
    </>
  );
};
